module.exports = __webpack_public_path__ + "img/2.c87e96ba.png";